import { useNavigate } from "react-router-dom";
import { MyItemsView } from "@/features/clinician/review-queue/components/MyItemsView";

export function ClinicianMyItemsPage() {
  const navigate = useNavigate();
  return <MyItemsView onOpenItem={(id) => navigate(`/clinician/my-items/${encodeURIComponent(id)}`)} />;
}
